
import { ApiResponse, ApiService } from 'src/services/core';
import { http } from '../core/http';
import { AxiosResponse } from 'axios';
import { env } from 'src/env';

export interface printerModel {
    appVersion?: number,
    defaultPrinter?: string,
    ipAddress?: string,
    macAddress?: string,
    pcName?: string,
    printers?: [],
    status? : number,
    statustext? : string
  }


var printRes = {} as printerModel;
class PrintService  {
    resp : ApiResponse<any>;
    printpdf = (data : any) : Promise<AxiosResponse<ApiResponse<object>,any>> => {
        // const article = { defaultPrinter: data };
        try {
			const response = http.post<any, AxiosResponse<ApiResponse<object>>>(env.REACT_APP_BARKOD_API_URL + "/print-pdf",data);
			return response;
		}
		catch (error) {
			return error;
		}
    }

    setprinter = (data : string) : Promise<AxiosResponse<object,any>> => {
      const article = { defaultPrinter: data };
      try {
			  const response = http.post<any, AxiosResponse<object>>(env.REACT_APP_BARKOD_API_URL + "/set-printer",article);
        return response;
      }
      catch (error) {
        return error;
      }
    }

    pcinfo = () : Promise<AxiosResponse<object,any>> => {
    try {
			const response  = http.get<any, AxiosResponse<printerModel>>(env.REACT_APP_BARKOD_API_URL + "/pc-info")
			return response;
		}
		catch (error) {
            return error;
		}
    }
}

export default new PrintService();
